import React from "react";
import BannerComp from "../Components/BannerComp";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function TermsCondition() {
  const policyList = [
    {
      title: "Return Policy",
      detail: [
        "The 15-Day 'No Questions Asked' Return Policy mean that the Buyer is free to return the Product; within the first 15 Days of the Receiving goods by informing us within the stipulated time frame.",
        "The Products has to be returned in 'As is original condition' to claim the Refund.",
        "Return Policy will not be applicable if any Damage/Alteration/used-up condition is found in the Product. Any Loss in value of the Product has to be settled by the Buyer. Refund will only be processed after the above conditions are fulfilled and in favor.",
        "Sejal Export's decision in accepting the product Returned will be teamed as 'Final & Binding' for both Parties involved. 'Customized & Special Orders' are not allowed for any Return/Exchanges.",
        "Return Shipping Charges plus 5% of Invoice Value (on Account of Import Duty) have to be borne by the Buyer",
      ],
    },
    {
      title: "Shipping Policy",
      detail: [
        "Shipping through India Post, FedEx, Malca-Amit and BVC.",
        "Express shipment will take 5-7 working days. Days mentioned are approximate days",
        "Please check with local import laws of your country before buying.",
        "Applicable Imports duties / customs charges or any TAX charged by the buyer's country ,will have to be borne by the buyer.",
        "We are not responsible for delay due to customs service in your country.",
      ],
    },
    {
      title: "Custom and Import Taxes",
      detail: [
        "Online Prices are 'NOT INCLUSIVE' of All Applicable Taxes/Duties.",
        "All applicable Local Import Laws/import Duties/Customs Charges/Taxes if any; have to be checked and borne by the Buyer and Sejal Exports holds no liability; thereof, or any delay due to Laws/Customs/Shipment Charges/in your country.",
      ],
    },
    {
      title: "Handling / Order Process Time",
      detail: [
        "Large and Varied Inventory enables Sejal Exports to process orders within 1-3 Days of Receiving Payment.",
        "Special/Customized Orders can be processed within 3-7 Working Days to match your parameters.",
        "National and Festive Holidays are excluded from Working Days for Order Closures.",
      ],
    },
    {
      title: "Tracking Your Order",
      detail: [
        "When your order is ready to be shipped, we will send you an e-mail with your tracking information.",
        "If you do not receive this information after stated handling time and after making your payment, please email and prompt us on websales@sejalgems.in",
      ],
    },
  ];
  return (
    <>
      <Header />
      <BannerComp
        title="Term & Conditions"
        image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROXXYAl8h7poqRmmynUIJhEwOUCxGUlXS2Lw&s"
      />
      {policyList.map((val) => (
        <section className="py-4 termsConditionSection">
          <div className="container">
            <h2>{val.title}</h2>
            <ul>
              {val.detail.map((value) => (
                <li>
                  <p>{value}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ))}
      <Footer />
    </>
  );
}
